/* CILSON – Produktseite v2: Texte, Badge, Versand-Fortschritt, Logistik-Akkordeon */
(() => {
  if (window.cilsonPdpV2) return;
  window.cilsonPdpV2 = true;

  const info = () => document.querySelector('.product__info-container');
  const THR = 150;
  const num = (s) => parseFloat(String(s).replace(/\./g, '').replace(',', '.')) || 0;

  // 3. "1 Stück = 2 m × 18,50 €" -> "1 Stück (2 m) × 18,50 €"; "inkl. MwSt." nicht dreifach
  const fixSum = () => {
    const r1 = document.querySelector('.cil-nb-sum-r1');
    if (r1) {
      const t = r1.textContent;
      const n = t.replace(/^(\d+\s+\S+)\s*=\s*([\d.,]+\s*m)\s*×/, '$1 ($2) ×');
      if (n !== t) r1.textContent = n;
    }
    const r3 = document.querySelector('.cil-nb-sum-r3');
    if (r3 && /inkl\. MwSt\.\s*·\s*/.test(r3.textContent)) {
      r3.textContent = r3.textContent.replace(/inkl\. MwSt\.\s*·\s*/, '');
    }
  };

  const fixTax = () => {
    const tax = document.querySelector('.product__info-container > .product__tax');
    if (!tax || tax.dataset.cil) return;
    tax.dataset.cil = '1';
    tax.childNodes.forEach((n) => {
      if (n.nodeType === 3 && /inkl\. MwSt\./.test(n.textContent)) {
        n.textContent = n.textContent.replace(/inkl\. MwSt\.\s*/, '');
      }
    });
  };

  // "Made in Germany" als Badge beim Titel (nach "Meistgekauft", falls vorhanden)
  const mig = () => {
    const title = document.querySelector('.product__info-container > .product__title');
    if (!title) return;
    let b = title.querySelector('.cil-mig2');
    const best = [...title.querySelectorAll('span, div')].find(
      (e) => e.children.length === 0 && /^\s*(meistgekauft|best seller)\s*$/i.test(e.textContent)
    );
    if (b && (!b.classList.contains('solo') || !best)) return;
    if (!b) {
      b = document.createElement('span');
      b.className = 'cil-mig2';
      b.innerHTML = '<i aria-hidden="true"></i>Made in Germany';
    }
    if (best) {
      b.classList.remove('solo');
      best.insertAdjacentElement('afterend', b);
      const h = best.getBoundingClientRect().height;
      if (h > 10) { b.style.height = h + 'px'; b.style.marginBottom = getComputedStyle(best).marginBottom; }
    } else {
      b.classList.add('solo');
      title.insertAdjacentElement('afterbegin', b);
    }
  };

  // 6. Fortschrittsbalken statt Haken beim kostenlosen Versand
  const freeBar = () => {
    // verwaiste Balken entfernen (entstehen, wenn .cil-nb-free in die Lieferbox umzieht und der alte Balken zurückbleibt)
    document.querySelectorAll('.cil-free-bar').forEach((b) => {
      const prev = b.previousElementSibling;
      if (!prev || !prev.classList.contains('cil-nb-free')) b.remove();
    });
    const f = document.querySelector('.cil-nb-free');
    if (!f) return;
    const txt = f.textContent;
    const ok = /erreicht|reached/i.test(txt);
    let pct = 100;
    if (!ok) {
      const m = txt.match(/([\d.]+,\d{2})\s*€/);
      pct = m ? Math.max(4, Math.min(100, Math.round((1 - num(m[1]) / THR) * 100))) : 0;
    }
    f.classList.toggle('ok', ok);
    let bar = f.nextElementSibling;
    if (!bar || !bar.classList.contains('cil-free-bar')) {
      bar = document.createElement('span');
      bar.className = 'cil-free-bar';
      bar.innerHTML = '<i></i>';
      f.insertAdjacentElement('afterend', bar);
    }
    const v = pct + '%';
    if (bar.style.getPropertyValue('--cil-free') !== v) bar.style.setProperty('--cil-free', v);
  };

  // Abholung in die Lieferbox
  const pickup = () => {
    const ship = document.querySelector('.cil-ship');
    const p = document.querySelector('.product__info-container pickup-availability');
    if (ship && p && p.parentElement !== ship && p.querySelector('.pickup-availability-info')) ship.appendChild(p);
  };

  // Verpackung & Logistik aufklappbar (Handy zu, Desktop offen)
  const logistics = () => {
    const lg = document.querySelector('.cil-lg');
    if (!lg || lg.dataset.cil) return;
    const head = lg.querySelector('.cil-lg-head');
    if (!head) return;
    lg.dataset.cil = '1';
    const open = window.innerWidth >= 750;
    lg.classList.toggle('zu', !open);
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    head.setAttribute('aria-expanded', String(open));
    const toggle = () => {
      const zu = lg.classList.toggle('zu');
      head.setAttribute('aria-expanded', String(!zu));
    };
    head.addEventListener('click', toggle);
    head.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  };

  // Produktidentifikation (Art.-Nr. · EAN · Typ) unten links auf das erste Produktbild legen
  const pid = () => {
    document.querySelectorAll('.product__media-wrapper > .cil-pid').forEach((chip) => {
      const item = chip.parentElement.querySelector('.product__media-item');
      if (!item) return;
      item.classList.add('cil-has-pid');
      item.appendChild(chip);
    });
  };

  const run = () => {
    if (!info()) return;
    fixSum(); fixTax(); mig(); freeBar(); pickup(); logistics(); pid();
  };

  let t;
  const schedule = () => { clearTimeout(t); t = setTimeout(run, 60); };
  const start = () => {
    run();
    [300, 900, 1800, 3500].forEach((ms) => setTimeout(run, ms));
    const root = info();
    if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
